<template>
  <div class="app-tariff-change-booking-modal">
    <b-modal id="tariff-change-booking-modal"
             :modal-class="['content-theme-'+ content.theme + ' tariff-change-booking-modal']"
             v-model="show_"
             data-qa="modal"
             :title=content.title
    >
      <BookableDetails :details="content.detailBoxes">
        <template v-for="slot in possibleChildSlotsFor('Details')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </BookableDetails>
      <dyn-slot :slot-data="slotData"><slot name="txtContent"></slot></dyn-slot>
      <div  v-if="showLink" class="document-link">
        <p>Die Vertragszusammenfassung finden Sie <a @click="download()" target="_blank"><slot name="txtDocument">hier</slot></a>.</p>
      </div>
      <template #modal-footer>
        <div id="bookable-actions"  v-if="actions" class="bookable-actions">
          <button v-for="action in actions" class="btn btn-default" :disabled="action.disabled" v-bind:key="action.type" @click="$emit(`click:${action.type}`)">
            {{action.text}}
          </button>
        </div>
        <dyn-slot :slot-data="slotData"><slot v-if="content.message" :name="`txtMessage${content.message.type}`"></slot></dyn-slot>
        <div class="message-boxes" v-if="content.messageBox">
          <div class="message-box"  v-for="message in content.messageBox" v-bind:key="message.id">
            <span v-html="message.text"></span>
          </div>
        </div>
        <slot name="txtAfterButton"></slot>
      </template>
    </b-modal>
  </div>
</template>

<script>

import { BModal } from 'bootstrap-vue'
import syncProperty from '@/mixins/syncProperty'
import BookableDetails from '@/components/process/generic/Tariff/generic/CurrentTariff/Details.vue'
import slotProxy from '@/mixins/slotProxy'
import axios from 'axios'
import FileSaver from 'file-saver'
import { mapGetters } from 'vuex'

export default {
  name: 'TariffChangeBookingModal',
  data () {
    return {
      downloadPending: false
    }
  },
  mixins: [
    syncProperty('show', 'show_'),
    slotProxy()
  ],
  components: { BookableDetails, BModal },
  computed: {
    showLink () {
      return (this.content.documentUrl !== null && this.content.documentUrl) && this.automaticExtension === true
    },
    slotData () {
      return this.content.slotData || {}
    },
    ...mapGetters([
      'accessToken'
    ])
  },
  methods: {
    download: function () {
      if (!this.downloadPending || this.btnAlreadyClicked) {
        this.downloadPending = true
        const me = this

        axios.get(this.content.documentUrl, {
          baseURL: this.$config.apiUrl || '',
          headers: {
            Authorization: `Bearer ${this.accessToken}`,
            Accept: 'application/pdf'
          },
          responseType: 'blob'
        }).then((response) => {
          const file = new Blob([response.data], { type: response.headers['content-type'] })
          FileSaver.saveAs(file, 'Vertragszusammenfassung.pdf')
          this.downloadPending = false
        }).catch((reason) => {
          me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
          this.downloadPending = false
        })
      }
    }
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    actions: {
      type: Array,
      default: () => []
    },
    btnAlreadyClicked: {
      type: Boolean,
      default: false
    },
    automaticExtension: {
      type: Boolean,
      default: true
    }
  }
}

</script>
